import { useEffect, useState } from "react";

import { getPaymentConfig } from "src/Api/services/paymentServices";

export const CLOSED_CLIENT_MESSAGE = "Este cliente está cerrado: reábrelo para seguir trabajando con él.";

// Si el back congela a los clientes cerrados (ENFORCE_CLOSED_CLIENTS). Puede cambiar sin deploy, así
// que se pide al montar; mientras no se sabe, o si falla, la pantalla queda como siempre.
export const useClosedClientsFrozen = () => {
    const [frozen, setFrozen] = useState(false);

    useEffect(() => {
        let active = true;
        getPaymentConfig()
            .then((resp) => {
                if (active) setFrozen(resp?.data?.closedClientsFrozen === true);
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, []);

    return frozen;
};

export const isClientFrozen = (frozen, client) => frozen && client?.status === "closed";

// Clientes que el coach puede elegir para algo nuevo: sin los congelados.
export const selectableClients = (clients, frozen) =>
    frozen ? (clients || []).filter((client) => client?.status !== "closed") : clients;
